import { useCallback, useState } from 'react';
import { FlatList, Pressable, RefreshControl, Text } from 'react-native';
import { useFocusEffect, useRouter } from 'expo-router';
import { useAuth } from '../context/AuthContext';
import { listOpenDisputes } from '../api/admin';
import { Submission } from '../types';
import { Card, EmptyState, ErrorText, ScreenContainer } from '../components/ui';
import { colors, fonts } from '../theme';
import { ApiError } from '../api/client';

export default function AdminDisputesScreen() {
  const { token } = useAuth();
  const router = useRouter();
  const [disputes, setDisputes] = useState<Submission[]>([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState<string | null>(null);

  const load = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    try {
      setDisputes(await listOpenDisputes(token));
      setLoadError(null);
    } catch (e) {
      setLoadError(e instanceof ApiError ? e.message : 'Không tải được danh sách khiếu nại, vui lòng thử lại.');
    } finally {
      setLoading(false);
    }
  }, [token]);

  useFocusEffect(
    useCallback(() => {
      load();
    }, [load]),
  );

  return (
    <ScreenContainer safeTop safeBottom>
      {loadError ? <ErrorText>{loadError}</ErrorText> : null}
      <FlatList
        data={disputes}
        keyExtractor={(item) => item.id}
        refreshControl={<RefreshControl refreshing={loading} onRefresh={load} />}
        ListEmptyComponent={!loading && !loadError ? <EmptyState text="Không có khiếu nại nào đang chờ xử lý" /> : null}
        renderItem={({ item }) => (
          <Pressable onPress={() => router.push(`/submission/${item.id}`)}>
            <Card>
              <Text style={{ fontSize: 16, fontFamily: fonts.bold, color: colors.text }}>
                {item.task?.title ?? 'Nhiệm vụ'}
              </Text>
              <Text style={{ color: colors.textMuted, marginTop: 2 }}>
                Shop: {item.task?.shop?.name ?? '—'}
              </Text>
              <Text style={{ color: colors.textMuted, marginTop: 2 }}>
                Người khiếu nại: {item.reviewer?.name ?? item.reviewerId}
              </Text>
              <Text style={{ color: colors.textMuted, marginTop: 6, fontSize: 12 }} numberOfLines={2}>
                Lý do: {item.disputeReason}
              </Text>
              <Text style={{ color: colors.textMuted, marginTop: 4, fontSize: 11 }}>
                Khiếu nại lúc:{' '}
                {item.disputedAt ? new Date(item.disputedAt).toLocaleString('vi-VN') : ''}
              </Text>
            </Card>
          </Pressable>
        )}
      />
    </ScreenContainer>
  );
}
